// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__vkbZb","list":"Sidebar_list__13HOG","text":"Sidebar_text__5Sl1v","activeLink":"Sidebar_activeLink__fcPDb"};